<template>
    <modal :modal-id="'manage-team-users-modal'"
           v-model="showModal"
           :title="modalTitle"
           :preloader="preloader"
           :modal-scroll="modalScroll"
           @submit="submit"
           @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <template v-else>
                <div v-for="(user, index) in usersList" :key="index"
                     class="d-flex align-items-center justify-content-between"
                     :class="{'pb-3 mb-3 border-bottom': index !== usersList.length - 1}">
                    <div class="media d-flex align-items-center">
                        <div class="avatars-w-50">
                            <app-avatar :title="user.full_name"
                                        :shadow="true"
                                        :img="$optional(user.profile_picture, 'full_url')"
                                        :alt-text="user.full_name"/>

                        </div>
                        <div class="media-body ml-3">
                            {{ user.full_name }}
                            <p class="text-muted font-size-90 mb-0">{{ user.email }}</p>
                        </div>
                    </div>
                    <div>
                        <a href="#" @click="removeUser(user, index)"
                           class="d-flex align-items-center text-muted font-size-90">
                            <app-icon name="trash" class="mr-1" width="19"/>
                            {{ $t('remove') }}
                        </a>
                    </div>
                </div>

                <form ref="form"
                      :data-url='`${TEAMS}/${team.id}/attach-users`'
                      class="mb-0">
                    <div class="mt-primary" ref="form" data-url="attach-user">
                        <app-input type="multi-select"
                                   :list="attachableUsers"
                                   list-value-field="full_name"
                                   :required="true"
                                   v-model="selectedUsers"/>
                    </div>
                </form>
            </template>
        </template>
    </modal>
</template>

<script>
import {ModalMixin} from "../../../mixins/ModalMixin";
import {axiosGet} from "../../../helpers/AxiosHelper";
import {GET_USERS, TEAMS} from "../../../config/ApiUrl";
import FormHelperMixins from "../../../mixins/global/FormHelperMixins";

export default {
    name: "ManageUsersModal",
    mixins: [ModalMixin, FormHelperMixins],
    props: {
        team: {
            required: true,
        }
    },
    data() {
        return {
            usersList: [],
            selectedUsers: [],
            attachableUsers: [],
            modalHeight: '',
            modalScroll: true,
            modalTitle: this.$t('manage_team_users'),
            TEAMS,
        }
    },
    created() {
        this.getAllUsers();
    },
    mounted() {
        $('#manage-team-users-modal').on('shown.bs.modal', (e) => {
            this.modalHeight = $("#manage-team-users-modal .modal-dialog").height();
            this.modalScroll = this.modalHeight > 530;
        });
    },
    watch: {
        'team.users.length': {
            handler: function (users) {
                this.usersList = this.team.users;
                this.getUsers({
                    users: this.collection(this.team.users).pluck('id')
                })
            },
            immediate: true
        }
    },
    methods: {
        getAllUsers() {
            this.usersList = this.attachableUsers.filter(user => {
                return this.selectedUsers.includes(user.id);
            }).concat(this.usersList);

            this.getUsers({
                users: this.collection(this.team.users).pluck('id').concat(this.selectedUsers)
            });
        },
        getUsers(payload) {
            const url = payload.users ? `${GET_USERS}?existing=${payload.users}` : GET_USERS;
            axiosGet(url).then(({data}) => {
                this.attachableUsers = data;
            });
        },
        removeUser(user, index) {
            this.preloader = true;
            const url = `${TEAMS}/${this.team.id}/detach-user/${user.id}`;
            this.axiosPost({
                url,
                data: {
                    roles: this.team.id
                }
            }).then(response => {
                this.toastAndReload(response.data.message, 'team-table')
                this.usersList = this.collection(this.usersList).removeObject(user.id);
                this.attachableUsers.concat([user])
            }).catch(error => {
                this.$toastr.e(error.response.data.message || error.response.statusText);
            }).finally(response => {
                this.preloader = false;
            });
        },
        submit() {
            let obj = {
                users: this.selectedUsers
            };
            this.save(obj);
        },
        afterSuccess(res) {
            $('#manage-team-users-modal').modal('hide');
            this.toastAndReload(res.data.message, 'team-table')
            this.$emit('input', false);
        },
    }
}
</script>
